export function LoaderCircleIcon({ className }) {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#paint0_angular_12734_28608_clip_path)' data-figma-skip-parse='true'>
        <g transform='matrix(0.02 0 0 0.02 20 20)'>
          <foreignObject x='-1050' y='-1050' width='2100' height='2100'>
            <div
              xmlns='http://www.w3.org/1999/xhtml'
              className={'cards-map__loader-foreign-object'}
              style={{
                background: 'conic-gradient(from 90deg, #00c853 0deg, rgba(0, 200, 83, 0) 0.036deg, #00c853 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1,
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM20 36.6667C29.2047 36.6667 36.6667 29.2047 36.6667 20C36.6667 10.7953 29.2047 3.33333 20 3.33333C10.7953 3.33333 3.33333 10.7953 3.33333 20C3.33333 29.2047 10.7953 36.6667 20 36.6667Z'
        data-figma-gradient-fill='{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.78431373834609985,&#34;b&#34;:0.32549020648002625,&#34;a&#34;:0.0},&#34;position&#34;:9.9999997473787516e-05},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.78431373834609985,&#34;b&#34;:0.32549020648002625,&#34;a&#34;:1.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.78431373834609985,&#34;b&#34;:0.32549020648002625,&#34;a&#34;:0.0},&#34;position&#34;:9.9999997473787516e-05},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.78431373834609985,&#34;b&#34;:0.32549020648002625,&#34;a&#34;:1.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:40.0,&#34;m01&#34;:3.7976430810812700e-14,&#34;m02&#34;:-3.5527136788005009e-14,&#34;m10&#34;:-2.0212862416810196e-14,&#34;m11&#34;:40.0,&#34;m12&#34;:-8.8817841970012523e-15},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M37.9694 16.0012C38.8823 15.8834 39.7178 16.528 39.8356 17.4409C39.9451 18.2895 40 19.1443 40 20C40 20.9205 39.2538 21.6667 38.3333 21.6667C37.4129 21.6667 36.6667 20.9205 36.6667 20C36.6667 19.287 36.6209 18.5746 36.5297 17.8674C36.4119 16.9545 37.0565 16.119 37.9694 16.0012Z'
        fill='#00C853'
      />
      <defs>
        <clipPath id='paint0_angular_12734_28608_clip_path'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM20 36.6667C29.2047 36.6667 36.6667 29.2047 36.6667 20C36.6667 10.7953 29.2047 3.33333 20 3.33333C10.7953 3.33333 3.33333 10.7953 3.33333 20C3.33333 29.2047 10.7953 36.6667 20 36.6667Z'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
